import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-connection-error-modal',
    templateUrl: './connection-error-modal.component.html',
    styleUrls: ['./connection-error-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatButton]
})
export class ConnectionErrorModalComponent {

  constructor(private dialogRef: MatDialogRef<ConnectionErrorModalComponent>) { }

  public close(): void {
    this.dialogRef.close();
  }
}
